/**
 * Target attributes a Custom Labels "Set labels" rule can write to
 * (custom_label_0–custom_label_4). Values match the feed attribute names
 * consumed by the backend (FP-17238).
 */
export enum CustomLabelsAttribute {
    CustomLabel0 = 'custom_label_0',
    CustomLabel1 = 'custom_label_1',
    CustomLabel2 = 'custom_label_2',
    CustomLabel3 = 'custom_label_3',
    CustomLabel4 = 'custom_label_4'
}

/** Option shape bound by the Attribute `ng-select`. */
export interface CustomLabelsAttributeOption {
    readonly value: CustomLabelsAttribute;
    readonly label: string;
}

/** Ordered custom_label_0–4 options for the Attribute dropdown. */
export const CUSTOM_LABELS_ATTRIBUTE_OPTIONS: readonly CustomLabelsAttributeOption[] = [
    { value: CustomLabelsAttribute.CustomLabel0, label: 'custom_label_0' },
    { value: CustomLabelsAttribute.CustomLabel1, label: 'custom_label_1' },
    { value: CustomLabelsAttribute.CustomLabel2, label: 'custom_label_2' },
    { value: CustomLabelsAttribute.CustomLabel3, label: 'custom_label_3' },
    { value: CustomLabelsAttribute.CustomLabel4, label: 'custom_label_4' }
];
